const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Hola',
    'Ref: Page content body':
      'A la llegada y la salida, asegúrese de recordar escanear su código QR de Bus',
  },
};
export default labels;
